export const getCategoriesLabel = (array_categories, refs, select_network) => {
  if (isNaN(array_categories[0])) return {all_categories: array_categories, first_category: array_categories[0]};

  const categories = refs.filter_network ? refs.filter_network.total_categories_service : null
  if (categories) {
    const new_m = array_categories.map((index_category) => {
      if (select_network.src === 'ig') {
        if (categories['labels'].find(i => i.id === index_category)) return categories['labels'].find(i => i.id === index_category).title
      } else {
        for (const key in categories) {
          if (categories[key].find(i => i.id === index_category))
            return categories[key].find(i => i.id === index_category).title
        }
      }
    })
    return {all_categories: new_m, first_category: new_m[0]};
  }
  return {all_categories: [], first_category: ''};
}